import axios from 'axios'

class BiomarkerWidget {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }

    onInit () {
        const categories = this._elem.querySelectorAll('[data-biomarker-category]')
        if (categories.length > 0) {
            for (let category of categories) {
                category.addEventListener('click', () => {
                    this.changeCategory(category.dataset.biomarkerCategory)
                })
                const catName = category.getAttribute('data-biomarker-category')
                axios.get('https://medichecks.eastsideapps.io/api/public/biomarker-category', {
                    params: {
                        name: catName
                    }
                }).then((response) => {
                    let data = response.data
                    if (!data.success) {
                        alert(data.message)
                    } else {
                        let page = this._elem.querySelector('[data-biomarker-content="' + catName + '"]')
                        let description = page.querySelector('.product-biomarkers__item__desc')
                        if (data.category.description) {
                            description.innerHTML = data.category.description
                        }
                        this._biomarkerAccordion(page, data.children)
                    }
                }).catch((error) => {
                    console.log(error)
                })
            }
        }
        const closes = this._elem.querySelectorAll('[data-biomarker-close]')
        if (closes.length > 0) {
            for (let close of closes) {
                close.addEventListener('click', () => {
                    this.close()
                })
            }
        }
        if (window.innerWidth > 768) {
            this.openFirst()
        }
    }
    openFirst () {
        const page = this._elem.querySelector('[data-biomarker-content]')
        const category = this._elem.querySelector('[data-biomarker-category]')
        if (page && category) {
            page.classList.add('active')
            category.classList.add('active')
        }
    }
    close () {
        const pages = this._elem.querySelectorAll('[data-biomarker-content]')
        if (pages.length > 0) {
            for (let page of pages) {
                page.classList.remove('active')
            }
        }
        const categories = this._elem.querySelectorAll('[data-biomarker-category]')
        if (categories.length > 0) {
            for (let category of categories) {
                category.classList.remove('active')
            }
        }
        document.body.classList.remove('no-scroll')
    }
    changeCategory (c) {
        const pages = this._elem.querySelectorAll('[data-biomarker-content]')
        if (pages.length > 0) {
            for (let page of pages) {
                page.classList.remove('active')
                if (page.dataset.biomarkerContent === c) {
                    page.classList.add('active')
                }
            }
        }
        const categories = this._elem.querySelectorAll('[data-biomarker-category]')
        if (categories.length > 0) {
            for (let category of categories) {
                category.classList.remove('active')
                if (category.dataset.biomarkerCategory === c) {
                    category.classList.add('active')
                }
            }
        }
        if (window.innerWidth <= 768) {
            document.body.classList.add('no-scroll')
        }
    }
    _biomarkerAccordion (page, markers) {
        const titles = page.querySelectorAll('[data-accordion-title]')
        const contents = page.querySelectorAll('[data-accordion-content]')
        for (var b = 0; b < markers.length; b++) {
            let marker = markers[b]
            const markerURL = marker.shopify_page_handle
            const markerName = marker.name.trim()
            const markerDescription = marker.short_description.trim()
            for (var t = 0; t < titles.length; t++) {
                let accordionTitle = titles[t].getAttribute('data-accordion-title').trim()
                if (accordionTitle === markerURL) {
                    titles[t].innerHTML = markerName
                    break
                }
            }
            for (var c = 0; c < contents.length; c++) {
                let accordionContents = contents[c].getAttribute('data-accordion-content').trim()
                if (accordionContents === markerURL) {
                    contents[c].innerHTML = markerDescription
                    break
                }
            }
        }
    }
}

export default BiomarkerWidget



// WEBPACK FOOTER //
// ./src/resources/scripts/components/BiomarkerWidget.js